module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    class: _vm.appClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('navigation-icon', {
    attrs: {
      "nav-icon-classes": _vm.navIconClasses
    },
    on: {
      "toggle-menu-state": _vm.toggleMenuState
    }
  })], 1), _vm._v(" "), _c('navigation-menu', {
    on: {
      "navigating": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('router-view', {
    attrs: {
      "scrollPosition": _vm.scrollPosition
    }
  }), _vm._v(" "), _c('page-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96c307ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 925
// module chunks = 1